module.exports = __webpack_public_path__ + "media/images/img_top_menu_1-60b00061d747d27088d7a9281e4dd4b3.png";